const valueColorClasses = {
  blue: 'text-blue-400',
  green: 'text-green-400',
  amber: 'text-amber-400',
  red: 'text-red-400',
  purple: 'text-purple-400',
  gray: 'text-gray-300',
};

export default function DataRow({ label, value, valueColor = 'gray' }) {
  const textColor = valueColorClasses[valueColor] || valueColorClasses.gray;

  return (
    <div className="flex items-center justify-between py-3 border-b border-[#1e2235] last:border-b-0">
      <span className="text-gray-400 text-sm">{label}</span>
      <span className={`font-medium ${textColor}`}>{value}</span>
    </div>
  );
}
